<template>
    <div class="card">
        <div class="card-header">
            <i class="fas fa-tv me-2"></i>{{ TR.projects }}
        </div>

        <div class="card-body">
            <DADataTableLazy
                v-if="tableOptions"
                ref="tv_table_ref"
                :tableOptions="tableOptions"
                :lazyUrl="lazyUrl"
                :lazyParam="lazyParam"
            />
        </div>
    </div>
</template>


<script scoped>
    import { onMounted, ref, watchEffect } from "vue";
    import { useStore } from "@/system_modules/store";
    // import moment from "moment-timezone";

    import { G, ajax } from "@/_common";
    import DADataTableLazy from "@/components/table/DADataTableLazy";

    export default {
        title: "TV",
        name: 'TvP',

        // metaInfo: {
        //     title: 'Default App Title',
        //     titleTemplate: '%s | vue-meta Example App',
        //     htmlAttrs: {
        //         lang: 'az-AZ'
        //     },
        //     meta: [
        //         { charset: 'utf-8' },
        //         { vmid: 'description', name: 'description', content: 'An example Vue application with vue-meta.' },
        //         { vmid: 'description', name: 'viewport', content: 'width=device-width, initial-scale=1' },

        //         { property: 'og:title', content: "Epiloge - Build your network in your field of interest" },
        //         { property: 'og:site_name', content: 'Epiloge' },
        //         { property: 'og:type', content: 'website' },
        //         { property: 'og:image', content: '/users/-main.jpg' },

        //         { name: 'robots', content: 'index,follow' },
        //     ]
        // },

        components: {
            DADataTableLazy,
        },
        setup() {
            const store = useStore();

            const tableOptions = ref();
            const tv = ref([]);
            const tv_table_ref = ref();
            // const tv_type = ref([
            //     { value: "_self", label: "Cari sehifede" },
            //     { value: "_blank", label: "Yeni sehife" }
            // ]);
            const TR = ref({});

            const lazyUrl = ref(store.getTVLazy());
            const lazyParam = ref(store.getDataTableParams());

            onMounted(async () => {
                // await ajax({
                //     url: store.getTV(),
                //     success: (e) => {
                //         let res = e.data || null;
                //         if (res) {
                //             tv.value = [];
                //             tv.value.push({ value: 0, label: `<b>${TR.value.main}</b>` });
                //             // tv.value = tv.value.concat(res.filter(e => e.parent == 0).map((e) => {
                //             tv.value = tv.value.concat(res.filter(e => e.status == 1).map((e) => {
                //                 return { value: e.id, label: e.translate[0].name };
                //             }));
                //             tableData.value = res;
                //             // tableData.value.forEach(x => x.create_date = new Date(x.create_date));
                //             tableData.value.forEach(x => x.create_date = new Date(moment.utc(x.create_date).tz(G.systemData.timezone?.value).format("YYYY-MM-DD HH:mm:ss")));
                //         }
                //     }
                // });
            });


            watchEffect(() => {
                TR.value = store.getTranslation();

                tableOptions.value = {
                    date_columns: {'video_date': 'date'},

                    // row_total: true,
                    // row_total_field: ['parent'],
                    // row_per_page: 5,

                    header_buttons: [
                        {
                            private: G.privateIfNotPermission("add"),
                            label: TR.value.add_title,
                            icon: "fas fa-plus me-1",
                            class: "btn-primary",
                            eventCallback: () => {
                                G.showModal({
                                    title: TR.value.add_title,
                                    // subTitle: `<span class="text-danger1">${TR.value.name}</span>`,
                                    // modal: false,
                                    page: "components/table/DynamicTable2",
                                    data: {
                                        permission_method: 'add'
                                    },
                                    table_columns_forlang: [
                                        {
                                            name: "title",
                                            title: TR.value.title,
                                            field_type: "text",
                                            required: true
                                        },
                                        {
                                            name: "description",
                                            title: TR.value.description,
                                            field_type: "editor-simple",
                                            required: false
                                        },
                                    ],
                                    table_columns: [
                                        {
                                            name: "preview_image",
                                            title: TR.value.preview,
                                            // value: (e) => e.image,
                                            value: "image",
                                            field_type: "label",
                                        },
                                        {
                                            name: "image",
                                            title: TR.value.image,
                                            // value: (e) => e.image,
                                            field_type: "image",
                                            fileSelectMode: 'basic',
                                            // fileSelectMode: 'advanced',
                                            fileMaxSize: G.uploadedFileSize,
                                            fileLimit: 1,
                                            fileMultiple: false,
                                        },
                                        {
                                            name: "video_date",
                                            title: TR.value.date,
                                            showTime: false,
                                            class: 'w-50',
                                            date_format: 'dd.mm.yy',
                                            field_type: "date",
                                            filter_mode: "date",
                                        },
                                        // {
                                        //     name: "link",
                                        //     title: TR.value.link,
                                        //     field_type: 'textarea',
                                        // },
                                        {
                                            name: "link",
                                            title: TR.value.link,
                                            field_type: 'textarea',
                                            onChange: (e, si, data, po) => {
                                                // let vid = po.newdata.link.split('v=')[1];
                                                let l = po.newdata.link;
                                                let re = new RegExp('[?|&]v=([^&]+)+', 'mgi');
                                                let re1 = new RegExp('([^\\?]+)', 'mgi');
                                                if( l.match(re) && l.match(re)[0] ){
                                                    let vid = l.match(re)[0].split('=')[1];
                                                    data['youtube_image'] = `https://img.youtube.com/vi/${vid}/sddefault.jpg`;
                                                    po['newdata']['youtube_image'] = `https://img.youtube.com/vi/${vid}/sddefault.jpg`;
                                                }
                                                else if( l.match(re1) && l.match(re1)[0] ){
                                                    let vid = l.match(re1)[0].split('/').at(-1);
                                                    data['youtube_image'] = `https://img.youtube.com/vi/${vid}/sddefault.jpg`;
                                                    po['newdata']['youtube_image'] = `https://img.youtube.com/vi/${vid}/sddefault.jpg`;
                                                }
                                                else{
                                                    data['youtube_image'] = '';
                                                    po['newdata']['youtube_image'] = '';
                                                }
                                            }
                                        },
                                        {
                                            name: "youtube_image",
                                            title: TR.value.youtube_image,
                                            field_type: 'preview_image',
                                            disabled: true,
                                        },
                                        {
                                            name: "status",
                                            title: TR.value.status,
                                            value: () => true,
                                            field_type: "switch",
                                            grouping: false,
                                            max: 30,
                                        },
                                    ],
                                    onModalClose: (e) => {
                                        G.closeModal(e);
                                    },
                                    toolbar: {
                                        leftSide: {
                                            buttons: [
                                                {
                                                    label: TR.value.close,
                                                    icon: "fas fa-times",
                                                    class: "btn-secondary",
                                                    eventCallback: (el) => {
                                                        G.closeModal(el);
                                                    },
                                                },
                                                {
                                                    private: G.privateIfNotPermission("add"),
                                                    label: TR.value.save,
                                                    icon: "fas fa-save",
                                                    class: "btn-primary",
                                                    eventCallback: async (res) => {
                                                        let e = res.newdata;

                                                        if( e && e.title != '' ){
                                                            let formData = new FormData();

                                                            if( e.image != null && typeof e.image === 'object' ){
                                                                formData.append("upload_image", e.image);
                                                            }

                                                            let tv_data = {
                                                                "video_date": G.dateToStr(e.video_date, "date"),
                                                                "link": e.link ? e.link.replace("\n|\r", "<br />") : '',
                                                                "youtube_image": e.youtube_image,
                                                                "translate": G.lang_list.map((a) => {
                                                                    return {
                                                                            "lang_id": a.value,
                                                                            "title": e.title[a.value] || e.title[1],
                                                                            "description": e.description[a.value] || e.description[1],
                                                                        };
                                                                }),
                                                                "status": e.status ? 1 : 0,
                                                            };
                                                            if( e.image != null && typeof e.image !== 'object' )
                                                                tv_data.image = e.image;

                                                            formData.append("data", JSON.stringify(tv_data));

                                                            await ajax({
                                                                url: store.getTV(),
                                                                method: 'post',
                                                                data: formData,
                                                                success: (x) => {
                                                                    let res = x.data || null;
                                                                    if ( x.status == 200 && res) {
                                                                        // res.create_date = new Date(res.create_date);
                                                                        // tableData.value.unshift(res);
                                                                        // tableData.value.push(res);
                                                                        tv_table_ref.value.loadLazyData();
                                                                        G.alert.success(TR.value.msg_add_success);

                                                                        tv.value.push({ value: res.id, label: res.translate[0].name });
                                                                    }
                                                                    else
                                                                        G.alert.error(res.detail);
                                                                },
                                                                // error: (x) => {
                                                                //     var res = x.response || {};
                                                                //     if( res.status && res.status == 422 ){
                                                                //         G.alert.error({title: TR.value.warning, msg: G.getErrorMessages(res.data.detail)});
                                                                //     }
                                                                //     else
                                                                //         G.alert.error({msg: TR.value.msg_add_failed});
                                                                // }
                                                            });
                                                            G.closeModal(res);
                                                        }
                                                        else
                                                            G.alert.warning({msg: TR.value.msg_input_name});
                                                    },
                                                },
                                            ],
                                        },
                                    },
                                });
                            },
                        },
                    ],
                    row_buttons: [
                        {
                            private: G.privateIfNotPermission("remove"),
                            label: "",
                            title: TR.value.remove,
                            icon: "fas fa-trash",
                            class: "text-danger",
                            eventCallback: (data) => {
                                G.alert.confirm({ title: TR.value.warning, msg: TR.value.msg_are_you_sure, yesTitle: TR.value.yes, yes: async () => {
                                    await ajax({
                                        url: store.getTVUpdate(data.id),
                                        method: 'delete',
                                        success: (e) => {
                                            let res = e.data || null;
                                            if ( e.status == 200 && res){
                                                // tableData.value.filter((x, i) => { if (x.id === data.id) tableData.value.splice(i, 1); } );
                                                tv_table_ref.value.loadLazyData();
                                                G.alert.success(res.detail);
                                            }
                                            else
                                                G.alert.error(res.detail);
                                        },
                                    });
                                }, yesIcon: 'fas fa-check', noIcon: 'fas fa-ban', noTitle: TR.value.no, no: () => {} })
                            },
                        },
                        {
                            // private: G.privateIfNotPermission("update"),
                            label: "",
                            title: TR.value.edit,
                            // icon: "fas fa-pencil-alt",
                            // class: "btn-primary",
                            icon: "fas fa-" + ( G.userHavePermission("update") ? 'pencil-alt' : 'search' ),
                            class: "text-" + ( G.userHavePermission("update") ? 'primary' : 'info' ),
                            eventCallback: (data) => {
                                data.permission_method = 'update';

                                G.showModal({
                                    title: TR.value.edit_title,
                                    subTitle: data.translate[0].name,
                                    dismiss: false,
                                    page: "components/table/DynamicTable2",
                                    data: data,
                                    table_columns_forlang: [
                                        {
                                            name: "title",
                                            value: (e) => e.title,
                                            title: TR.value.title,
                                            field_type: 'text',
                                            required: true
                                        },
                                        {
                                            name: "description",
                                            value: (e) => e.description,
                                            title: TR.value.description,
                                            field_type: 'editor-simple',
                                            required: false
                                        },
                                    ],
                                    table_columns: [
                                        {
                                            name: "preview_image",
                                            title: TR.value.preview,
                                            // value: (e) => e.image,
                                            value: "image",
                                            field_type: "label",
                                        },
                                        {
                                            name: "image",
                                            title: TR.value.image,
                                            value: (e) => e.image,
                                            field_type: "image",
                                            fileSelectMode: 'basic',
                                            fileMaxSize: G.uploadedFileSize,
                                            fileLimit: 1,
                                            fileMultiple: false,
                                        },
                                        {
                                            name: "id",
                                            title: TR.value.id,
                                            value: "id",
                                        },
                                        {
                                            name: "video_date",
                                            value: "video_date",
                                            // value: (e) => G.dateToStr(e.video_date, "date"),
                                            title: TR.value.date,
                                            showTime: false,
                                            date_format: 'dd.mm.yy',
                                            field_type: "date",
                                            class: 'w-50',
                                        },
                                        {
                                            name: "link",
                                            value: "link",
                                            title: TR.value.link,
                                            field_type: 'textarea',
                                            onChange: (e, si, data, po) => {
                                                let l = po.newdata.link;
                                                let re = new RegExp('[?|&]v=([^&]+)+', 'mgi');
                                                let re1 = new RegExp('([^\\?]+)', 'mgi');
                                                if( l.match(re) && l.match(re)[0] ){
                                                    let vid = l.match(re)[0].split('=')[1];
                                                    data['youtube_image'] = `https://img.youtube.com/vi/${vid}/sddefault.jpg`;
                                                    po['newdata']['youtube_image'] = `https://img.youtube.com/vi/${vid}/sddefault.jpg`;
                                                }
                                                else if( l.match(re1) && l.match(re1)[0] ){
                                                    let vid = l.match(re1)[0].split('/').at(-1);
                                                    data['youtube_image'] = `https://img.youtube.com/vi/${vid}/sddefault.jpg`;
                                                    po['newdata']['youtube_image'] = `https://img.youtube.com/vi/${vid}/sddefault.jpg`;
                                                }
                                                else{
                                                    data['youtube_image'] = '';
                                                    po['newdata']['youtube_image'] = '';
                                                }
                                            }
                                        },
                                        {
                                            name: "youtube_image",
                                            value: "youtube_image",
                                            title: TR.value.youtube_image,
                                            field_type: 'preview_image',
                                            disabled: true,
                                        },
                                        {
                                            name: "create_date",
                                            value: (e) => G.formatLocale(e.create_date),
                                            title: TR.value.create_date,
                                            field_type: "label",
                                        },
                                        {
                                            name: "status",
                                            title: TR.value.status,
                                            value: (e) => e.status == 1 ? true : false,
                                            field_type: "switch",
                                            grouping: false,
                                            max: 30,
                                        },
                                    ],
                                    toolbar: {
                                        leftSide: {
                                            buttons: [
                                                {
                                                    label: TR.value.close,
                                                    icon: "fas fa-times",
                                                    class: "btn-secondary",
                                                    eventCallback: (el) => {
                                                        G.closeModal(el);
                                                    },
                                                },
                                                {
                                                    private: G.privateIfNotPermission("update"),
                                                    label: TR.value.save,
                                                    icon: "fas fa-save",
                                                    class: "btn-primary",
                                                    eventCallback: async (res) => {
                                                        let e = res.newdata;

                                                        if( e && e.title != '' ){

                                                            let formData = new FormData();
                                                            if( e.image != data.image && typeof e.image === 'object' ){
                                                                formData.append("upload_image", e.image);
                                                            }
                                                            let tv_data = {
                                                                "video_date": G.dateToStr(e.video_date, "date"),
                                                                "link": e.link ? e.link.replace("\n|\r", "<br />") : '',
                                                                "youtube_image": e.youtube_image,
                                                                "translate": G.lang_list.map((a) => {
                                                                    return {
                                                                            "lang_id": a.value,
                                                                            "title": e.title[a.value] || e.title[1],
                                                                            "description": e.description[a.value] || e.description[1],
                                                                        };
                                                                }),
                                                                "status": e.status ? 1 : 0,
                                                            };

                                                            if( e.image != data.image && typeof e.image !== 'object' )
                                                                tv_data.image = e.image;

                                                            formData.append("data", JSON.stringify(tv_data));

                                                            await ajax({
                                                                url: store.getTVUpdate(data.id),
                                                                method: 'patch',
                                                                data: formData,
                                                                success: (x) => {
                                                                    let res = x.data || null;
                                                                    if (res) {
                                                                        // res.create_date = new Date(res.create_date);
                                                                        // tableData.value.forEach(
                                                                        //     (s) => { if ( s.id === res.id ) { s = res; } }
                                                                        // );
                                                                        // for (let a in res) {
                                                                        //     data[a] = res[a];
                                                                        // }
                                                                        tv_table_ref.value.loadLazyData();
                                                                        G.alert.success(TR.value.msg_update_success);
                                                                    }
                                                                },
                                                            });
                                                            G.closeModal(res);
                                                        }
                                                        else
                                                            G.alert.warning({msg: TR.value.msg_input_title});
                                                    },
                                                },
                                            ],
                                        },
                                    },
                                });
                            },
                        },
                        {
                            private: G.privateIfNotPermission("update"),
                            name: 'status',
                            title: TR.value.status,
                            value: (e) => e.status == 0 ? false : true,
                            class: 'text-center',
                            element: 'switch',
                            eventName: 'change',
                            eventCallback: async (data, event) => {
                                await ajax({
                                    url: store.getTVActivate(data.id, event.target.checked ? 1 : 0),
                                    method: 'post',
                                    success: () => {
                                        // let res = a.data;
                                        tv_table_ref.value.loadLazyData();
                                        G.alert.success({toast: true, msg: TR.value.msg_success});
                                        // res.create_date = new Date(moment.utc(res.create_date).tz(G.systemData.timezone?.value).format("YYYY-MM-DD HH:mm:ss"));
                                        // tableData.value.forEach(
                                        //     (s) => { if ( s.id === res.id ) { s = res; } }
                                        // );
                                        // for (let a in res) {
                                        //     data[a] = res[a];
                                        // }
                                    }
                                });
                            },
                        },
                    ],
                    data_table_columns: [
                        // {
                        //     name: 'status',
                        //     title: TR.value.status,
                        //     value: (e) => e.status == 0 ? false : true,
                        //     class: 'text-center',
                        //     element: 'switch',
                        //     eventName: 'change',
                        //     eventCallback: async (data, event) => {
                        //         await ajax({
                        //             url: store.getTVActivate(data.id, event.target.checked ? 1 : 0),
                        //             method: 'post',
                        //             success: (a) => {
                        //                 let res = a.data;
                        //                 G.alert.success({msg: TR.value.msg_update_success});
                        //                 res.create_date = new Date(moment.utc(res.create_date).tz(G.systemData.timezone?.value).format("YYYY-MM-DD HH:mm:ss"));
                        //                 tableData.value.forEach(
                        //                     (s) => { if ( s.id === res.id ) { s = res; } }
                        //                 );
                        //                 for (let a in res) {
                        //                     data[a] = res[a];
                        //                 }
                        //             }
                        //         });
                        //     },
                        //     filter: false,
                        //     sortable: false,
                        //     exportable: false,
                        // },
                        {
                            name: "id",
                            title: TR.value.id,
                            value: "id",
                            class: 'text-center',
                            filter: false,
                        },
                        {
                            name: "image",
                            value: (e) => `<img src="${
                                                        e.image
                                                            ? e.image
                                                            : "/assets/img/noimg.png"
                                                    }"
                                                    alt="${e.image}"
                                                    class="border img-circle-cover"
                                                />`,
                            title: TR.value.image,
                            exportable: false,
                            sortable: false,
                            class: 'text-center',
                            filter: false,
                        },
                        {
                            name: "translate.0.title",
                            value: (e) => e.translate[0].title,
                            title: TR.value.title,
                        },
                        {
                            name: "video_date",
                            value: "video_date",
                            title: TR.value.date,
                            filters: {
                                operator: "or",
                                constraints: [{ value: null, matchMode: "dateBefore" }],
                            },
                            date_format: 'dd.mm.yy',
                            field_type: "date",
                            filter_mode: "date",
                            showTime: false,
                            class: 'text-center',
                        },
                        {
                            name: "youtube_image",
                            value: "youtube_image",
                            title: TR.value.youtube_image,
                            class: 'text-center',
                            filter: false,
                            visible: false,
                        },
                        {
                            name: "link",
                            value: (e) => e.link !== '' ? '<i class="fas fa-check text-success" />' : '<i class="fas fa-square border text-white" />',
                            title: TR.value.link,
                            class: 'text-center',
                            sortable: false,
                            filter: false
                        },
                        {
                            name: "create_date",
                            value: "create_date",
                            title: TR.value.create_date,
                            class: 'text-center',
                            filters: {
                                operator: "or",
                                constraints: [{ value: null, matchMode: "dateBefore" }],
                            },
                            date_format: 'dd.mm.yy',
                            field_type: "date",
                            filter_mode: "datetime",
                        },
                    ],
                };

            });

            // function componentToHex(c) {
            //     var hex = c.toString(16);
            //     return hex.length == 1 ? "0" + hex : hex;
            // }
            // function rgbToHex(r, g, b) {
            //     return "#" + componentToHex(r) + componentToHex(g) + componentToHex(b);
            // }

            return {
                TR,
                tv_table_ref,
                tableOptions,
                lazyUrl,
                lazyParam,
            };
        },
    };
</script>

